import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-canvas-window-generic',
  templateUrl: './canvas-window-generic.component.html',
  styleUrls: ['./canvas-window-generic.component.scss']
})
export class CanvasWindowGenericComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
